import { Route } from '@angular/router';

export const AI_SEARCH: Route[] = [
    {
        path: '',
        loadComponent: () => import('./ai-search.component').then((comp) => comp.AiSearchComponent)
    }
];
